import React, {useState, useEffect, useRef, useContext} from 'react';
import { translateCol } from "../../../custom/columnI18n";
import { useTranslation } from "react-i18next";

import { useSelector } from 'react-redux';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { TabMenu } from 'primereact/tabmenu';
import { AuthContext } from "../../../Header/auth - context";
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog'; // <- mora biti renderovana
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import CustomDropdown from '../../../custom/customDropdown';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { InputTextarea } from 'primereact/inputtextarea';

const OslobadjajuciTekst = () => {
  const { t } = useTranslation();

        const toast = useRef(null);
        const formRef = useRef(null);
        const auth = useContext(AuthContext);
        const company = useSelector(state => state.company)
        const user = useSelector(state => state.user)
        const [selectedRowIdItem , setSelectedRowIdItem] = useState(null);
        const isSelected = (row) => String(getIdItem(row)) === String(selectedRowIdItem);
        const [drzaveOptions, setDrzaveOptions] = useState([])
        const [valuteOptions, setValuteOptions] = useState([])
        const [izabran, setIzabran] = useState(false)
        const [idItem, setIdItem] = useState(null)
        const [popuni, setPopuni] = useState(false)
        const [globalFilter, setGlobalFilter] = useState(null);
        const [first, setFirst] = useState(0);
        const [tableData, setTableData] = useState(null);
        const [allColumns, setAllColumns] = useState([]);
        const [selectedColumns, setSelectedColumns] = useState([]);
        const [originalColumnOrder, setOriginalColumnOrder] = useState([]);
        const [porukaTimeRange, setPorukeTimeRange] = useState(null)
        const [formSubmitted, setFormSubmitted] = useState(false);
        const getIdItem = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null;
        ///DATA

        const [sefReasonsOptions, setSefReasonsOptions] = useState([]);
        const [sefReasonsLoading, setSefReasonsLoading] = useState(false);

        const ublKategorijeOptions = [
            { value: 'S',  label: 'S  — Standardna stopa (20%, 10%)' },
            { value: 'Z',  label: 'Z  — Nulta stopa sa pravom na odbitak (izvoz/prevoz — čl.24)' },
            { value: 'E',  label: 'E  — Oslobođenje bez prava na odbitak (čl.25)' },
            { value: 'O',  label: 'O  — Van teritorije PDV (čl.11, čl.12)' },
            { value: 'AE', label: 'AE — Primalac je poreski dužnik — reverse charge (čl.10)' },
            { value: 'R',  label: 'R  — Ne smatra se prometom (čl.6)' },
        ];

         const [formData, setFormData] = useState({
        SifraStavke: null,
        PDVStopa: null,
        Opis: '',
        TekstOslobodjenja: '',
        sefKod: '',
        ublKategorija: ''
        });


    const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

    const popuniRedove = async (id) => {
  
        if(!id) {
             toast.current.show({
                        severity: "warn",
                        summary: t('admin.m_upozorenje_2'),
                        detail: t('admin.m_niste_izabrali_karticu_da_bi_popunili_po'),
                        life: 3000,
                    });
        } else {
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/finance/GetRelease", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                               
                                popuniStavke(data)
                                
                               toast.current.show({
                                severity: "success",
                                summary: t('admin.m_uspesno_popunjavanje_podataka_oslobadjaj'),
                                life: 3000,
                                });
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
        }
          
    }

  const popuniStavke = (apiData) => {
    setFormData({
        SifraStavke:       apiData[0].SifraStavke       || null,
        PDVStopa:          apiData[0].PDVStopa           || null,
        Opis:              apiData[0].Opis               || '',
        TekstOslobodjenja: apiData[0].TekstOslobodjenja || '',
        sefKod:            (apiData[0].sefKod        || '').trim(),
        ublKategorija:     (apiData[0].ublKategorija || '').trim()
      });
};

   useEffect(()=>{
    if(!formSubmitted){
                   let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              }
                          };
                          fetch(process.env.REACT_APP_BACKEND_URL + "/finance/GetReleaseTextAndTypes", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                
                                const stringifiedJson = data[0][""];
                                const parsedData = JSON.parse(stringifiedJson);

                                setTableData(parsedData.ReleaseTextDB)


                                 if (parsedData.ReleaseTextDB && parsedData.ReleaseTextDB.length > 0) {
                                                const columns = Object.keys(parsedData.ReleaseTextDB[0])
                                                    .filter(key => !['ID'].includes(key))
                                                    .map(key => ({
                                                    label: key,
                                                    value: key
                                                    }));
                                        
                                                 
                                                setAllColumns(columns);
                                                const originalOrder = Object.keys(parsedData.ReleaseTextDB[0]);
                                                setOriginalColumnOrder(originalOrder);
                                                
                                                // Select first 5 columns by default (or adjust as needed)
                                                setSelectedColumns(columns.slice(0, 10).map(col => col.value));
                                                }
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                              
    }
      },[formSubmitted])



  // Ucitaj listu SEF razloga pri mount-u
  useEffect(() => {
    fetch(process.env.REACT_APP_BACKEND_URL + '/sef/GetExemptionReasons', {
      method: 'GET',
      headers: { Authorization: 'Bearer ' + auth.token }
    })
      .then(r => r.json())
      .then(data => {
        if (Array.isArray(data)) setSefReasonsOptions(data);
      })
      .catch(() => {});
  }, []);

  // "Preuzmi tekstove - SEF" — osvezi sa SEF API-ja i exportuj Excel
  const handlePreuzmiSefTekstove = async () => {
    setSefReasonsLoading(true);
    try {
      const res = await fetch(process.env.REACT_APP_BACKEND_URL + '/sef/GetExemptionReasons', {
        method: 'GET',
        headers: { Authorization: 'Bearer ' + auth.token }
      });
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error('Neispravan odgovor.');
      setSefReasonsOptions(data);

      // Export u Excel sa srpskim kolonama
      const workbook = new ExcelJS.Workbook();
      const ws = workbook.addWorksheet('SEF razlozi oslobođenja');

      const koloneSR = [
        { key: 'ReasonId',    header: 'ID razloga' },
        { key: 'Key',         header: 'SEF Kod (Ključ)' },
        { key: 'Category',    header: 'UBL Kategorija' },
        { key: 'Law',         header: 'Zakon' },
        { key: 'Article',     header: 'Član' },
        { key: 'Paragraph',   header: 'Stav' },
        { key: 'Point',       header: 'Tačka' },
        { key: 'Subpoint',    header: 'Podtačka' },
        { key: 'Text',        header: 'Tekst oslobođenja' },
        { key: 'FreeFormNote',header: 'Napomena' },
        { key: 'ActiveFrom',  header: 'Aktivan od' },
        { key: 'ActiveTo',    header: 'Aktivan do' },
      ];

      ws.columns = koloneSR.map(k => ({ header: k.header, key: k.key, width: k.key === 'Text' ? 80 : 20 }));
      const headerRow = ws.getRow(1);
      headerRow.font = { bold: true };
      headerRow.eachCell(cell => {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD9E1F2' } };
        cell.border = { top: { style: 'medium' }, left: { style: 'medium' }, bottom: { style: 'medium' }, right: { style: 'medium' } };
      });

      data.forEach(row => {
        const r = ws.addRow(koloneSR.map(k => row[k.key] ?? ''));
        r.eachCell(cell => {
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });
      });

      const date = new Date();
      const dt = date.toLocaleString('sr-RS', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit', timeZone:'Europe/Belgrade' }).replace(/,/g, '');
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `SEF razlozi oslobođenja - ${dt}.xlsx`);

      toast.current.show({ severity: 'success', summary: `Preuzeto ${data.length} razloga sa SEF-a.`, life: 3000 });
    } catch (e) {
      toast.current.show({ severity: 'error', summary: t('admin.m_greska_pri_preuzimanju_sef_tekstova'), detail: e.message, life: 4000 });
    } finally {
      setSefReasonsLoading(false);
    }
  };

const resetData = ()=> {
        setFormData({
        SifraStavke: '',
        PDVStopa: '',
        Opis: '',
        TekstOslobodjenja: '',
        sefKod: '',
        ublKategorija: ''
        });
}
const handleDeleteFuncRelease = () => {
       
            confirmDialog({
            message: "Želite obrisati oslobađajući tekst?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: acceptDelete,
            reject: rejectDelete,
            });

    };

    const acceptDelete = async () => {
 
  if (idItem) {
    setFormSubmitted(true)
     let requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({
            id: idItem
          }),
        };
        
        fetch(process.env.REACT_APP_BACKEND_URL + "/finance/DeleteRelease", requestOptions)
          .then(handleErrors)
          .then((data) => {
            
             toast.current.show({
                severity: "success",
                summary: t('admin.m_uspesno_pasiviziranje_oslobadjajuceg_tek'),
                life: 3000,
                });
                resetData()
                setIdItem(null)
                setFormSubmitted(false)
                setSelectedRowIdItem(null)
          })
          .catch((error) => {
            error.json().then((errorMessage) => {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errorMessage.message,
                life: 3000,
              });
              console.log(errorMessage);
            });
          });
  } else {
        toast.current.show({
            severity: "warn",
            summary: t('admin.m_niste_izabrali_oslobadjajuci_tekst_za_br'),
            life: 3000,
            });
  }
   

  };
  const rejectDelete = () => {
    console.log("Odbijeno brisanje podataka!");
  }; 
  
  function toUtcIso(d) {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + 'Z';
    }

   const handleFormSubmit = (e) => {
  
                       e.preventDefault(); // bitno da ne submituje bez validacije
                  setFormSubmitted(true)
              if (formRef.current && !formRef.current.checkValidity()) {
                  formRef.current.reportValidity(); // prikazuje native browser poruke
                  return;
              }
      handleUploadAndSave()
   }
          const handleUploadAndSave = () => {
         
              confirmDialog({
              message: "Jel ste sigurni da želite nastaviti sa unosom?",
              acceptLabel: "Da",
              rejectLabel: "Ne",
              icon: "pi pi-info-circle",
              acceptClassName: "p-button-danger",
              accept: acceptInsert,
              reject: rejectInsert,
              });
          
  
      };

      const acceptInsert = async () => {
  
              //DATA
                  const hasAnyValue = Object.values(formData).some(value => {
                  if (value === null || value === '') return false;
  
                  // Check if it's a valid Date object
                  if (value instanceof Date && isNaN(value.getTime())) return false;
  
                  return true;
                  });
                  const payload = {
                        ...formData
                        };

                  if(izabran && idItem){
                 if(hasAnyValue){                        
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: Number(idItem),
                                formData: payload
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/finance/UpdateRelease", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                             
                               if(data){
                                    if(data[0].message && data[0].message != 'Nema izmena u podacima oslobađajućeg teksta.' && data[0].message != 'Nedostaje id za UPDATE.' 
                                        && data[0].message != 'Zapis nije pronađen ili nije aktivan.' && data[0].message != 'Izmena nije moguća: postoji drugi aktivan oslobađajući tekst za ovu šifru stavke i PDV stopu.'){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                return
                               }

                                toast.current.show({
                                severity: "success",
                                summary: t('admin.m_uspesna_izmena_podataka_oslobadjajuceg_t'),
                                life: 3000,
                                });
                           
                                setFormSubmitted(false)
                                
                                setIdItem(null)
                                setSelectedRowIdItem(null)
                                setIzabran(false)
                                resetData()
                                } 
                                
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: t('admin.m_upozorenje_2'),
                        detail: t('admin.m_niste_popunili_podatke_oslobadjajuceg_te_0'),
                        life: 3000,
                    });
                }
           
           
                } else {
                  if(hasAnyValue){
                      
                            let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  formData: payload
                              }),
                          };
                          
                          await fetch(process.env.REACT_APP_BACKEND_URL + "/finance/InsertRelease", requestOptions)
                              .then(handleErrors)
                              .then((data) => {

                                  if(data) {
                                        if(data.message != 'Postoji već isti oslobađajući tekst!' && data.message != 'Uspešan unos oslobađajućeg teksta!'){
                                        toast.current.show({
                                        severity: "error",
                                        summary: "Error",
                                        detail: data.message,
                                        life: 3000,
                                        });
                                        return
                                        } 
                                  }
                                  
                                  resetData()
                                  setFormSubmitted(false)
  
                                 toast.current.show({
                                  severity: "success",
                                  summary: t('admin.m_uspesan_unos_podataka_oslobadjajuceg_tek'),
                                  life: 3000,
                                  });

                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                  } else {
                          toast.current.show({
                          severity: "warn",
                          summary: t('admin.m_upozorenje_2'),
                          detail: t('admin.m_niste_popunili_podatke_oslobadjajuceg_te'),
                          life: 3000,
                      });
                  }
            }
  
    };
      const rejectInsert = () => {
      console.log("Odbijen unos podataka!");
    };     
  
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name in formData) {
        setFormData(prev => ({ ...prev, [name]: value }));
        }
    };
  
  
  const invalidControl = (data) => {
    if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata
  
    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };


  const exportExcel = async () => {
      if (!selectedColumns || selectedColumns.length === 0) return;
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Oslobađajući tekst');
  
      const headers = selectedColumns.map(c => translateCol(t, c));

      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
          };
          cell.border = {
              top: { style: 'medium' },
              left: { style: 'medium' },
              bottom: { style: 'medium' },
              right: { style: 'medium' }
          };
      });
  
      tableData.forEach((rowData) => {
          const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
          row.eachCell((cell) => {
              cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
              };
          });
      });
  
      worksheet.columns.forEach((column, i) => {
          const lengths = [
              headers[i].length,
              ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
          ];
          column.width = Math.max(...lengths) + 2;
      });
  
      const date = new Date();
      const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Belgrade'
      };
      const serbianDateTime = date.toLocaleString('sr-RS', options)
          .replace(/\s/g, ' ')
          .replace(/,/g, '');
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `Oslobađajući tekst - ${company.companyName} - ${serbianDateTime}.xlsx`);
  };
  const header = (
    <div className="export-buttons fakture-stavke-header">
      <div className="fakture-stavke-radnje">
        <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
        <Button
          type="button"
          icon={sefReasonsLoading ? 'pi pi-spin pi-spinner' : 'pi pi-download'}
          label={t('admin.preuzmiSef')}
          severity="info"
          onClick={handlePreuzmiSefTekstove}
          disabled={sefReasonsLoading}
          style={{ fontSize: '0.8rem', padding: '0.2rem 0.6rem' }}
        />
        {selectedRowIdItem && (
          <Button type="button" icon="pi pi-trash" severity="danger" rounded onClick={handleDeleteFuncRelease} data-pr-tooltip={t('common.delete')} />
        )}
      </div>
      <input
        type="search"
        onInput={(e) => setGlobalFilter(e.target.value)}
        placeholder={t('nova.phPretraga')}
        className="p-inputtext p-component"
      />
    </div>
  );

     const isButtonColumn = (field) => {
    return field.startsWith('Izaberi') || 
           field.includes('File') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument'); // Generic document
  };

    const chooseItem = (rowData) => {
        const id = getIdItem(rowData);

        setSelectedRowIdItem((prev) => {
        const next = String(prev) === String(id) ? null : String(id);

        if(next) {
        setIdItem(next)
        popuniRedove(id)
        setIzabran(true) 
        }
        else {
        setIdItem(null)
        resetData()
        setIzabran(false) 
        }

        return next;
    });
    }

     const previewBodyTemplate = (rowData, field) => {
      const filePathsString = rowData[field];
      if (!filePathsString) return '-';
     
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <Button
                label='Izaberi'
                icon="pi pi-eye"
                type="button"
                className="p-button-text p-button-sm"
                onClick={(e) => chooseItem(rowData)}
              />
            
        </div>
      );
    };

   return (
       <div style={{marginTop:"1%"}}> 
        <Toast ref={toast} />        

        <ConfirmDialog />
            <div className='col-12'>
                          <div className='blagajnaDashboard dnevniceDashboard'>
                             <Card>
                            <form autoComplete="off" ref={formRef} style={{marginTop:'1%'}}>
                              <div style={{minWidth:'100%', marginBottom: '1%'}}>
                                <fieldset style={{border:'1px solid #ced4da', borderRadius:'4px', padding:'12px 12px 10px', margin:'0', width:'100%'}}>
                                    <legend style={{textAlign:'center', padding:'0 12px', fontWeight:'600', color:'#6c757d', fontSize:'0.85rem', width:'auto'}}>SEF</legend>
                                    <div style={{display:'flex'}}>
                                        <div style={{display:'flex', flexDirection:'column', margin:'1%', maxWidth: '48%'}}>
                                            <label htmlFor="ublKategorija">{t('admin.ublKategorija')}:</label>
                                            <CustomDropdown
                                                id="ublKategorija"
                                                name="ublKategorija"
                                                value={formData.ublKategorija || null}
                                                options={ublKategorijeOptions}
                                                onChange={handleChange}
                                                optionLabel="label"
                                                placeholder={t('magacin.phKategoriju')}
                                            />
                                        </div>
                                        <div style={{display:'flex', flexDirection:'column', margin:'1%', maxWidth: '48%'}}>
                                            <label htmlFor="sefKod">{t('admin.sefKod')}:</label>
                                            <CustomDropdown
                                                id="sefKod"
                                                name="sefKod"
                                                value={formData.sefKod || null}
                                                options={
                                                    (formData.ublKategorija
                                                        ? sefReasonsOptions.filter(r => r.Category === formData.ublKategorija)
                                                        : sefReasonsOptions
                                                    ).map(r => ({
                                                        value: r.Key,
                                                        label: r.Key + ' | ' + (r.Text.length > 70 ? r.Text.slice(0, 70) + '…' : r.Text)
                                                    }))
                                                }
                                                onChange={handleChange}
                                                optionLabel="label"
                                                placeholder={formData.ublKategorija === 'S' ? 'Standardna stopa — nije potreban' : 'Izaberi SEF kod'}
                                                disabled={formData.ublKategorija === 'S'}
                                            />
                                        </div>
                                    </div>
                                </fieldset>
                                </div>
                            <div className="gridLicni">
                              <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                    <label htmlFor="SifraStavke">{t('nova.sifraStavke')}:</label>
                                    <InputText
                                    id="SifraStavke" 
                                    name="SifraStavke" 
                                    value={formData.SifraStavke} 
                                    required
                                    invalid={invalidControl(formData.SifraStavke)}
                                    onChange={handleChange}
                                    type='number'
                                    /* Šifra stavke je broj iz knjigovodstva (npr. 115), ne procenat —
                                       ranije je ovde stajao max={100} prepisan sa PDV stope ispod,
                                       pa forma nije puštala šifru veću od 100. Baza (INT) i procedura
                                       nemaju gornju granicu. */
                                    min={0} step={1} />
                                </div>
                                 <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                    <label htmlFor="PDVStopa">{t('admin.pdvStopa')}:</label>
                                    <InputText
                                    id="PDVStopa"
                                    name="PDVStopa"
                                    value={formData.PDVStopa}
                                    required
                                    invalid={invalidControl(formData.PDVStopa)}
                                    onChange={handleChange}
                                    type='number'
                                    min={0} max={100}  />
                                </div>

                            <div style={{display: 'flex', flexDirection:'column', minWidth: '100%'}} className="col-12 md:col-6">
                                <label htmlFor="Opis">{t('nova.opis')}:</label>
                                <InputTextarea 
                                    variant="filled" 
                                    id="Opis" 
                                    name="Opis" 
                                    value={formData.Opis} 
                                    onChange={handleChange} 
                                    invalid={invalidControl(formData.Opis)}
                                    rows={5} 
                                    cols={30} />
                                </div>
                              <div style={{display: 'flex', flexDirection:'column', minWidth: '100%'}} className="col-12 md:col-6">
                                <label htmlFor="TekstOslobodjenja">{t('admin.tekstOslobodjenja')}:</label>
                                <InputTextarea 
                                    variant="filled" 
                                    id="TekstOslobodjenja" 
                                    name="TekstOslobodjenja" 
                                    value={formData.TekstOslobodjenja} 
                                    onChange={handleChange} 
                                    invalid={invalidControl(formData.TekstOslobodjenja)}
                                    rows={5} 
                                    cols={30} />
                                </div>
                            </div>
                            <div className="formUnosZap buttonUnosZap">
                            <button type="submit" onClick={handleFormSubmit} style={{minWidth:"fit-content", marginTop:'2%'}} className="btn btn-success">
                                {izabran ? "SAČUVAJ" : "UNOS"}
                            </button>
                            </div>
                            </form>
                          </Card>
                          <Card>
                               <Tooltip target=".export-buttons>button" position="bottom" />
                                   <DataTable
                                          value={tableData || []}
                                          paginator
                                          rows={10}
                                          first={first}
                                          globalFilter={globalFilter}
                                          onPage={(e) => setFirst(e.first)}
                                          scrollable
                                          header={header}
                                          scrollHeight="50vh"
                                          emptyMessage={t('common.noDataTable')}
                                          resizableColumns
                                          className="turePregledTable stavke-tabela"
                                          columnResizeMode="expand"
                                          rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
                                        >
                                          {selectedColumns.map((colKey) => {
                                          const colMeta = allColumns.find(col => col.value === colKey);
                                          return (
                                            <Column
                                              key={colKey}
                                              field={colKey}
                                              header={translateCol(t, colMeta?.label || colKey)}
                                              sortable
                                              body={(rowData) => {
                                                if (isButtonColumn(colKey)) {
                                                  return previewBodyTemplate(rowData, colKey);
                                                }
                                                return rowData[colKey] || '-';
                                              }}
                                              style={{ minWidth: '150px'}}
                                            />
                                          );
                                        })}
                                    </DataTable>
                          </Card>
                          </div>
            </div>                                

       </div>
)
}

export default OslobadjajuciTekst;